// const LOG = false;

// const BALL_SIZE = 38;
// const BORDER_SIZE = 57;
// const HOLE_RADIUS = 46;

// const DELTA = 1/100;

// let DISPLAY = true;
// let SOUND_ON = true;
// let GAME_STOPPED = true;

// let KEYBOARD_INPUT_ON = true;

// let TRAIN_ITER = 100;
// let AI_ON = true;
// let AI_PLAYER_NUM = 1;
// let DISPLAY_TRAINING = false;
window.LOG = false;

window.BALL_SIZE = 38;
window.BORDER_SIZE = 57;
window.HOLE_RADIUS = 46;

window.DELTA = 1/100;

window.DISPLAY = true;
window.SOUND_ON = true;
window.GAME_STOPPED = true;

window.KEYBOARD_INPUT_ON = true;

window.TRAIN_ITER = 100;
window.AI_ON = true;
window.AI_PLAYER_NUM = 1;
window.DISPLAY_TRAINING = false;

// export {
//     LOG,
//     BALL_SIZE,
//     BORDER_SIZE,
//     HOLE_RADIUS,
//     DELTA,
//     DISPLAY,
//     SOUND_ON,
//     GAME_STOPPED,
//     KEYBOARD_INPUT_ON,
//     TRAIN_ITER,
//     AI_ON,
//     AI_PLAYER_NUM,
//     DISPLAY_TRAINING,
// }